// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AskDocumentQuestion_ConversationFragment } from './AskDocumentQuestion.generated';
import { gql } from '@apollo/client';
import { AskDocumentQuestion_ConversationFragmentDoc } from './AskDocumentQuestion.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubscribeDocumentQuestionSubscriptionVariables = Types.Exact<{
  workflowTrackerId: Types.Scalars['ID']['input'];
}>;


export type SubscribeDocumentQuestionSubscription = { __typename?: 'Subscription', subscribeDocumentQuestion: { __typename?: 'AskDocumentQuestionStreamEvent', textDelta?: string | null, result?: { __typename?: 'AskDocumentQuestionResult', answer: string, supportingParagraphIds: Array<string>, conversation: (
        { __typename?: 'Conversation' }
        & AskDocumentQuestion_ConversationFragment
      ) } | null } };

export const Operations = {
  Subscription: {
    SubscribeDocumentQuestion: 'SubscribeDocumentQuestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const SubscribeDocumentQuestionDocument = gql`
    subscription SubscribeDocumentQuestion($workflowTrackerId: ID!) {
  subscribeDocumentQuestion(workflowTrackerId: $workflowTrackerId) {
    textDelta
    result {
      answer
      supportingParagraphIds
      conversation {
        ...AskDocumentQuestion_Conversation
      }
    }
  }
}
    ${AskDocumentQuestion_ConversationFragmentDoc}`;

/**
 * __useSubscribeDocumentQuestionSubscription__
 *
 * To run a query within a React component, call `useSubscribeDocumentQuestionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeDocumentQuestionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeDocumentQuestionSubscription({
 *   variables: {
 *      workflowTrackerId: // value for 'workflowTrackerId'
 *   },
 * });
 */
export function useSubscribeDocumentQuestionSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeDocumentQuestionSubscription, SubscribeDocumentQuestionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeDocumentQuestionSubscription, SubscribeDocumentQuestionSubscriptionVariables>(SubscribeDocumentQuestionDocument, withSubscriptionIgnoreResults(options));
      }
export type SubscribeDocumentQuestionSubscriptionHookResult = ReturnType<typeof useSubscribeDocumentQuestionSubscription>;
export type SubscribeDocumentQuestionSubscriptionResult = Apollo.SubscriptionResult<SubscribeDocumentQuestionSubscription>;